document.addEventListener("DOMContentLoaded", function () {
  let currentCount = 16;
  let productCountElement = document.querySelector(".js-collection-count");
  let loadMoreButton = document.querySelector(".js-load-more-products");
  let productContainer = document.querySelector(".js-collection-results");
  let progressBar = document.querySelector(".js-progress-bar");

  let totalCount = productCountElement ? parseInt(productCountElement.getAttribute("data-products-count"), 10) : 0;

  if (loadMoreButton && productContainer && productCountElement && progressBar) {
    let buttonTextSpan = loadMoreButton.querySelector("span");
    let originalText = buttonTextSpan ? buttonTextSpan.textContent : "Load More";
    let loadingText = loadMoreButton.getAttribute("data-loading-text") || "Loading...";

    function updateProgressBar() {
      let progress = (currentCount / totalCount) * 100;
      progressBar.style.width = `${progress}%`;
    }
    updateProgressBar();

    loadMoreButton.addEventListener("click", function () {
      if (currentCount >= totalCount) {
        loadMoreButton.style.display = "none";
        return;
      }

      if (buttonTextSpan) {
        buttonTextSpan.textContent = loadingText;
      }

      let nextPage = Math.ceil(currentCount / 16) + 1;
      let collectionHandle = document.querySelector(".js-collection-handle").getAttribute("data-handle");

      fetch(`/collections/${encodeURIComponent(collectionHandle)}?page=${nextPage}`)
        .then(response => response.text())
        .then(data => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(data, "text/html");
          let newItems = doc.querySelectorAll(".js-collection-results > *");

          newItems.forEach(item => productContainer.appendChild(item.cloneNode(true)));

          currentCount += newItems.length;

          if (currentCount >= totalCount) {
            productCountElement.textContent = totalCount;
          } else {
            productCountElement.textContent = currentCount;
          }

          updateProgressBar();

          if (currentCount >= totalCount) {
            loadMoreButton.style.display = "none";
          } else if (buttonTextSpan) {
            buttonTextSpan.textContent = originalText;
          }

          setTimeout(function () {
            applyMatchHeightPerRow("[data-match-height]");
            initializeObservers();
          }, 100);
        })
        .catch(error => {
          console.error("Error fetching more products:", error);
          if (buttonTextSpan) {
            buttonTextSpan.textContent = originalText;
          }
        });
    });
  }
});